<div class="dialogWrapper" [ngClass]="data.type">
    <header>
        <i class="fa fa-warning"></i>
        <h2>{{ data.title | translate }}</h2>
    </header>

    <div class="text-body" [innerHTML]="data.body | translate | safeHtml"></div>
    @if (data.additionalWarningText) {
        <div>
            <div class="infoNotification warning">
                <i class="fa-solid fa-warning"></i>
                <span>{{ data.additionalWarningText | translate }}</span>
            </div>
        </div>
    }
    <div>
        @if (data.deletedEntityCompanyName) {
            <p>
                <strong>{{ 'generalKeywords.supplier' | translate }}: </strong> {{ data.deletedEntityCompanyName }}
            </p>
        }
        @if (data.deletedEntityName) {
            @if (isArrayOfEntities) {
                <strong>{{ data.deletedEntityType | translate }}: </strong>
                <div class="listBody">
                    @if (data.useOrderedList) {
                        <ol>
                            @for (entityName of data.deletedEntityName; track entityName) {
                                <li>{{ entityName }}</li>
                            }
                        </ol>
                    } @else {
                        <ul>
                            @for (entityName of data.deletedEntityName; track entityName) {
                                <li>{{ entityName }}</li>
                            }
                        </ul>
                    }
                </div>
            } @else {
                <p>
                    <strong>{{ data.deletedEntityType | translate }}: </strong> {{ data.deletedEntityName }}
                </p>
            }
        }

        @if (data.isWithCompanyConfirmation) {
            <input
                type="text"
                [placeholder]="
                    data.shouldNotTranslatePlaceholder ? data.confirmationInputPlaceholder : (data.confirmationInputPlaceholder | translate)
                "
                (input)="confirmationInputOnInput($event)"
            />
        }
    </div>
    <footer>
        <button
            class="button"
            [class.primary]="data.usePrimaryButtonColor"
            [class.delete-btn]="!data.usePrimaryButtonColor"
            (click)="close(true)"
            [disabled]="data.isWithCompanyConfirmation && !isConfirmed"
        >
            @if (data.mainButtonTextOverwrite) {
                {{ data.mainButtonTextOverwrite | translate }}
            } @else {
                {{ 'generalKeywords.delete' | translate }}
            }
        </button>
        <button class="button cancel-btn" (click)="close(false)">{{ 'generalKeywords.cancel' | translate }}</button>
    </footer>
</div>
